import './ErrorScreen.scss';

import React from 'react';
import { useTranslation } from 'src/i18n';

export default function NotFoundScreen () {
  const { t } = useTranslation();

  return (
    <div className='error-screen' data-testid='not-found-screen'>
      <div className='error-screen-text'>
        <h1>{t('error.looksLikeYoureLost')}</h1>
        <p>{t('error.pageDoesNotExist')} <span role='img' aria-label='crying face emoji'>😢</span></p>
      </div>
    </div>
  );
}
